import React from 'react';

import {
  Box, Card, Filter, useWindowSize,
} from 'vindi-ds-components';

import tokens from 'vindi-ds-tokens';

import useFilterSubscriptions from '../hooks/useFilterSubscriptions';
import FiltersSubscriptions from './filters';
import TableCardSubscriptions from './table_card';
import TableSubscriptions from './table';
import ModalExport from './modal_export';
import ModalMassEdit from './modal_mass_edit';
import EmptyStateSubscriptions from './empty_state';

const ListComponent = ({ subscriptions }) => {
  const { isMobile } = useWindowSize();
  const RootContainer = isMobile ? React.Fragment : Card;
  const Table = isMobile ? TableCardSubscriptions : TableSubscriptions;

  return (
    <RootContainer noShadow>
      <Table subscriptions={subscriptions} />

      <Box px={2} pb={3} bgcolor={!isMobile && tokens.color.prsm.neutral['000'].value}>
        <Filter.Pagination />
      </Box>
    </RootContainer>
  );
};

const ListSubscriptions = () => {
  const {
    listing,
    modalDownloadRef,
    modalMassEditRef,
    filterFields,
  } = useFilterSubscriptions();

  const { isLoading, status, data } = listing.query;

  const handleClickDownload = () => modalDownloadRef.current.open();
  const handleClickMassEdit = () => modalMassEditRef.current.open();

  if (isLoading || status === 'idle' || filterFields === null) return null;

  return (
    <Filter.FilterProvider {...listing}>
      <Box mb={5}>
        <FiltersSubscriptions
          onClickDownload={handleClickDownload}
          onClickMassEdit={handleClickMassEdit}
          filterFields={filterFields}
        />
      </Box>

      {data.subscriptions?.length ? (<ListComponent subscriptions={data.subscriptions} />)
        : <EmptyStateSubscriptions />}

      <ModalExport modalRef={modalDownloadRef} />
      <ModalMassEdit listing={listing} modalRef={modalMassEditRef} />
    </Filter.FilterProvider>
  );
};

export default ListSubscriptions;
